{
  "行业管理": "Industry management",
  "新增行业": "Add industry",
  "编辑行业": "Edit industry",
  "行业已删除": "Industry deleted",
  "删除后无法恢复。已被引用的行业请使用停用。": "Deletion cannot be undone. Disable industries that are already in use.",
  "该行业已被引用，请使用停用": "This industry is in use. Disable it instead.",
  "行业代码": "Industry code",
  "行业名称": "Industry name",
  "英文名称": "English name",
  "创建后不可修改": "Cannot be changed after creation",
  "小写字母开头，仅支持小写字母、数字和连字符": "Start with a lowercase letter; use lowercase letters, numbers, and hyphens",
  "行业代码不能使用 all": "The industry code cannot be all",
  "停用后不可新增选用，已有信息保留。": "Disabled industries cannot be newly selected. Existing information is retained.",
  "行业代码、中文或英文名称": "Industry code, Chinese or English name",
  "{{name}}启用状态": "{{name}} availability"
}
